import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import { weUserImage2 } from 'data/weraise-data/donar-data';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ReactSelect from 'react-select';
import {
  AttachmentsItems,
  ListItemData,
  SoftBadeItem
} from './ProjectCommonComponents';

const ProjectProposal = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [projectStatus, setProjectStatus] = React.useState([]);

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const citiesData = ['Mogadishu', 'Nairobi', 'Ruiru', 'Karachi'];
  const attachments = [
    { id: '1', title: 'winter.jpg', type: 'image/jpeg', size: 121212 },
    { id: '2', title: 'winter.png', type: 'image/jpeg', size: 1212 },
    { id: '3', title: 'title.zip', type: 'application/zip', size: 21212 },
    { id: '4', title: 'doc.pdf', type: 'application/pdf', size: 121432121 },
    { id: '5', title: 'data.cvs', type: 'text/csv', size: 121212 },
    { id: '6', title: 'winter 1.png', type: 'image/jpeg', size: 1212 },
    { id: '7', title: 'title.zip', type: 'application/zip', size: 21212 },
    { id: '8', title: 'tutorial.mp4', type: 'video/mp4', size: 12122243121 }
  ];

  const projectStatusOptions = [
    { value: '1', label: 'Complete' },
    { value: '2', label: 'Pending' },
    { value: '3', label: 'In Progress' },
    { value: '4', label: 'Backlog' },
    { value: '5', label: 'ToDo' }
  ];

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Card className="mb-3">
        <Card.Header className="bg-100">
          <Card.Title className="fw-medium mb-0">
            <FontAwesomeIcon icon={'paperclip'} className="me-2" />
            AL007 | Al-Walidayn Orphanage Centre for boys
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Flex justifyContent={'between'} alignItems="center">
            <Flex alignItems={'center'}>
              <Avatar src={weUserImage2} size="2xl" />
              <div className="ms-2">
                <p className="mb-0">Ali Mohamed</p>
                <p className="mb-0 text-500">Project Manager</p>
              </div>
            </Flex>
            <Button className="px-md-5">Edit Form</Button>
          </Flex>
          <hr />
          <div className="font-base">
            <ListItemData
              title="Project Title"
              value="Foundation construction started"
            />
            <ListItemData title="Project Category" value="Orphanages" />
            <ListItemData title="Start Date" value="01/01/2023" />
            <ListItemData title="End Date" value="01/01/2024" />
            <ListItemData title="Number of Beneficiaries" value="895" />
            <ListItemData
              title="City(ies)"
              content={
                <div className="w-75">
                  <SoftBadeItem data={citiesData} showTotal />
                </div>
              }
            />
            <ListItemData title="Total Cost" value="$ 20,000" />
            <ListItemData
              title="Average Cost Per Beneficiaries"
              value="$ 1,000"
            />
            <ListItemData
              title="Project Description"
              content={
                <>
                  <p className="fs-0 mb-0">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Duis aliquet ligula vitae facilisis vulputaterutrum cursus
                    lacinia. Praesent consectetur semper nunc, sit amet rutrum
                    dui commodo a. Lorem ipsum dolor.
                  </p>
                  <p className="fs-0 mb-0">
                    Please refer back to :
                    <a className="ms-1" href="#">
                      This link
                    </a>
                  </p>
                  <p className="fs-0 mb-0">
                    for Short video placeholder for use in website templates and
                    live mockups.
                  </p>
                </>
              }
              direction="column"
            />
            <ListItemData
              title="Case Study"
              content={
                <p className="fs-0 mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
                  aliquet ligula vitae facilisis vulputat{' '}
                  <a className="ms-1" href="#">
                    Read More
                  </a>
                </p>
              }
              direction="column"
            />
            <ListItemData
              title="Feasibility"
              content={
                <p className="fs-0 mb-0">
                  Lorem ipsum dolor sit amet, consectetur advulputat
                  <a className="ms-1" href="#">
                    Read More
                  </a>
                </p>
              }
              direction="column"
            />
            <ListItemData
              title="Project Charter"
              content={
                <p className="fs-0 mb-0">
                  Lorem ipsum dolor sit amet, consectetur adipuet ligula vitae
                  facilisis vulputat
                  <a className="ms-1" href="#">
                    Read More
                  </a>
                </p>
              }
              hr={false}
              direction="column"
            />
          </div>
          <AttachmentsItems
            attachments={attachments}
            deleteItem={id => console.log(id)}
            downloadAllClick={() => console.log('Download all')}
          />
        </Card.Body>
      </Card>
      <Card className="mb-3">
        <Card.Header>
          <Card.Title className="fw-medium mb-0">Project Status</Card.Title>
        </Card.Header>
        <Card.Body className="pt-0">
          <Row className="g-3">
            <Form.Group as={Col} md="6" controlId="First Authentication">
              <Form.Label>
                First Authentication <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="First Authentication"
              />
              <Form.Control.Feedback type="invalid">
                Required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="Second Authentication">
              <Form.Label>
                Second Authentication <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Second Authentication"
              />
              <Form.Control.Feedback type="invalid">
                Required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md={12}>
              <Form.Label>Status</Form.Label>
              <ReactSelect
                closeMenuOnSelect={true}
                options={projectStatusOptions}
                placeholder="Select"
                classNamePrefix="react-select"
                value={projectStatus}
                onChange={value => setProjectStatus(value)}
                menuPosition="fixed"
              />
            </Form.Group>
            <Form.Group as={Col} md={12} controlId="Comments">
              <Form.Label>Comments</Form.Label>
              <Form.Control as="textarea" rows={4} required />
            </Form.Group>
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body>
          <Flex
            justifyContent={'between'}
            className="flex-column flex-md-row align-items-center"
          >
            <p className="mb-0 fs-2 fw-medium">Update Project</p>
            <Button
              className="w-215px mt-2 mt-md-0"
              onClick={() => navigate(-1)}
            >
              Submit
            </Button>
          </Flex>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default ProjectProposal;
